// Componente wrapper que renderiza el step de información de sucursal según el país

import { BranchSettings } from "../../../../services/dto/request/branches-request-dto";
import { BranchBasicInfo } from "../../../../services/dto/request/branches-request-dto";
import { BranchStatus } from "../../../../constants/branch-status";
import { useFlowPages } from "../../../../hooks/useFlowPages";

export interface BranchInfoStepProps {
  branchBasicInfo: BranchBasicInfo;
  branchSettings: BranchSettings;
  errors: Record<string, string>;
  handleBranchBasicInfoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBranchSettingsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSwitchChange: (e: React.ChangeEvent<HTMLInputElement>, type: "branchConfig" | "branchBasicInfo" | "manager") => void;
  withSplitTip: boolean;
  disabled: boolean;
  branchStatus?: BranchStatus;
  isEditMode?: boolean;
  existingFiles?: {
    afipFile: string | null;
    managerDniFront: string | null;
    managerDniBack: string | null;
    managerSelfie: string | null;
  };
}

/**
 * Componente wrapper que renderiza el formulario de información de sucursal
 * según el país del usuario (Argentina o República Dominicana)
 */
export function BranchInfoStep(props: BranchInfoStepProps) {
  const FormComponent = useFlowPages({
    page: 'branchInfoStep',
    props,
  });

  return <>{FormComponent}</>;
}
